export function init($name = '') {
    const trigger = $($name + '-button');

    if (!trigger.length) {
        return;
    }

    trigger.each(function() {
        const formId = $(this).data('form');
        const modal = $('body').find($name + '-modal[data-form="' + formId + '"]');
        const modalClose = modal.find($name + '-modal-close');

        $(this).click(function(e) {
            e.preventDefault();

            $('body').addClass('modal-opened-form');

            modal.fadeIn();

            $('html,body').animate({scrollTop: 0}, 600, function() {
                $('html').addClass('modal-opened-form');
            });
        });

        modalClose.click(function(e) {
            e.preventDefault();

            modal.fadeOut(function() {
                $('html, body').removeClass('modal-opened-form');
            });
        });
    });
}